module.exports = __webpack_public_path__ + "static/media/br-pi.faaa861b.svg";